export const runClinicalEngine = (data) => {
  const signals = [];
  const differentials = [];
  let treatment = [];

  if (data.redFlags && data.redFlags.length > 0) {
    signals.push("URGENT: Red flags present. Immediate medical clearance may be required.");
  }

  if (data.symSeverity >= 7 || data.painIrritability === "High irritability") {
    signals.push("High irritability / Acute pain presentation. Modify physical exam to avoid exacerbation.");
    treatment.push("Focus on pain modulation, modalities, and gentle ROM. Avoid aggressive stretching.");
  } else if (data.painIrritability === "Low irritability") {
    treatment.push("Focus on progressive loading, strength, and return to function.");
  }

  if (data.symptomProgression === "Gradually worsening") {
    differentials.push("Consider degenerative changes or repetitive overuse syndrome.");
  } else if (data.symptomProgression === "Acute onset" && data.traumaSeverity.includes("High-energy")) {
    differentials.push("Rule out acute structural failure (fracture, gross instability, massive tear).");
  }

  if (data.painBehavior && data.painBehavior.includes("Night pain")) {
    differentials.push("Rule out systemic/malignancy if insidious onset, otherwise consider severe inflammatory component.");
  }

  if (differentials.length === 0) differentials.push("Mechanical MSK pathology");
  if (treatment.length === 0) treatment.push("Pending AI comprehensive synthesis and physical exam correlation.");

  return { signals, differentials, treatment };
};
